import Access from './access';

export default Access;
